import common from './common-educabot'

export default {
  ...common.button,
  color: `#FFB800`,
  '::before': {
    display: `none`
  },
  '::after': {
    ...common.button['::after'],
    width: '115%',
    bg: `white`,
    border: '0.5px solid',
    borderColor: `#FFB800`
  }
}